import { render, staticRenderFns } from "./mian.vue?vue&type=template&id=10ae6443&scoped=true"
import script from "./mian.vue?vue&type=script&lang=js"
export * from "./mian.vue?vue&type=script&lang=js"
import style0 from "./mian.vue?vue&type=style&index=0&id=10ae6443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae6443",
  null
  
)

export default component.exports